/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apievalextfieldform, apicustomereval
// apisystemsettingByCode
} from '@/api';
import { mapActions } from 'vuex';
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Rater from "vux/src/components/rater/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import ImgUpload from '@/components/ImgUpload';
import CustomFormList from '@/components/CustomFormList';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    Cell: Cell,
    XButton: XButton,
    Rater: Rater,
    XTextarea: XTextarea,
    ImgUpload: ImgUpload,
    CustomFormList: CustomFormList
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    anonymity: {
      type: [String, Number],
      default: 0
    },
    oid: String
  },
  data: function data() {
    return {
      is_anonymous_eval: 0,
      loading: false,
      currValue: this.value,
      isSolveProblemList: [{
        name: i18n.tc("308"),
        value: '1'
      }, {
        name: i18n.tc("309"),
        value: '0'
      }],
      orderInfo: {},
      customFormListData: [],
      form: {
        evalField: [],
        isSolveProblem: [],
        evaluateServiceQualityScore: 0,
        evaluateServiceAttitudeScore: 0,
        evaluateProcessSpeedScore: 0,
        remark: '',
        pics: []
      }
    };
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      // if (val) {
      //   this.$setLeft({
      //     control: true,
      //     onSuccess: () => {
      //       this.currValue = false
      //     }
      //   })
      // } else {
      //   this.$setLeft({ control: false })
      // }
      this.$emit('input', val);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('globalStore', ['_ApiSession'])), {}, {
    goDetail: function goDetail() {
      this.$router.push({
        name: 'ProjectDetail',
        params: {
          oid: this.oid
        }
      });
    },
    submit: function submit() {
      var _this = this;
      var isSolveProblem = this.form.isSolveProblem;
      if ((isSolveProblem.length === 0 || !isSolveProblem[0]) && this.orderInfo.e_solve_problem) {
        this.$vux.toast.text(i18n.tc("310"));
        return false;
      }
      if (this.form.evaluateServiceQualityScore === 0 && this.orderInfo.e_service_quality_score) {
        this.$vux.toast.text(i18n.tc("311"));
        return false;
      }
      if (this.form.evaluateServiceAttitudeScore === 0 && this.orderInfo.e_service_attitude_score) {
        this.$vux.toast.text(i18n.tc("312"));
        return false;
      }
      if (this.form.evaluateProcessSpeedScore === 0 && this.orderInfo.e_process_speed_score) {
        this.$vux.toast.text(i18n.tc("313"));
        return false;
      }
      this.$refs.customFormList.formValidate().then(function (valid) {
        if (valid) {
          _this.loading = true;
          // 通过表单验证逻辑
          apicustomereval({
            oid: _this.oid,
            is_solve_problem: _this.form.isSolveProblem[0],
            evaluate_service_quality_score: _this.form.evaluateServiceQualityScore * 20,
            evaluate_service_attitude_score: _this.form.evaluateServiceAttitudeScore * 20,
            evaluate_process_speed_score: _this.form.evaluateProcessSpeedScore * 20,
            evaluate_remark: _this.form.remark,
            image_descri_list: _this.form.pics,
            list: _this.form.evalField
          }, 'post').then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this.loading = false;
                      if (!res.success) {
                        _context.next = 10;
                        break;
                      }
                      _this.$vux.toast.text(i18n.tc("314"));
                      _this.$emit('on-success');
                      _context.next = 6;
                      return _this._ApiSession();
                    case 6:
                      // 评价完 更新待评价信息 防止已评价工单 仍有未评价提示
                      if (Number(_this.anonymity) === 1) {
                        _this.$router.push({
                          name: 'Home'
                        });
                      }
                      _this.currValue = false;
                      _context.next = 11;
                      break;
                    case 10:
                      _this.$vux.toast.text(res.message);
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          // 表单验证失败逻辑
        }
      });
    }
  }),
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return apievalextfieldform({
                oid: _this2.oid
              }).then(function (res) {
                if (!res.success) return;
                _this2.customFormListData = res.data.list || [];
                _this2.orderInfo = res.data.orderMap || {};
              });
            case 2:
              if (Number(_this2.anonymity) === 1) _this2.currValue = true;
            // 匿名评价
            // await apisystemsettingByCode({ code: 40001 }).then(res => {
            //   if (res.success) {
            //     this.is_anonymous_eval = +res.data.value
            //     if (+this.anonymity === 1 && this.is_anonymous_eval) {
            //       this.currValue = true // 匿名评价
            //     }
            //   }
            // })
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};